module.exports = "/_next/static/images/bbb72a5642ec8ee0aac3f3d213ef231c-google-pay.png";